<template>
  <div class="common-page order-review">
    <div class="right-box">
      <div class="right-top">
        <el-input
          class="right-search"
          style="width: 100%"
          clearable
          v-model="searchForm.keyword"
          @input="handleSearch"
          autocomplete="off"
          suffix-icon="el-icon-search"
          placeholder="请输入司机姓名或手机号码"></el-input>
      </div>
      <div class="right-center-box">
        <template v-if="tableData && tableData.length">
          <div
            class="center-box"
            v-for="(item, index) in tableData"
            :key="item.driverId"
            :class="item.driverId === selectUserId ? 'selectTab' : ''"
            @click="handleClick(item, index)">
            <div class="center-box-1">
              <div class="list-1">
                <el-image :src="cheImage" class="label-img"></el-image>
                <span class="center-name">{{ item.carNumber }}</span>
              </div>
              <div class="list-2">
                <!--              {{ item.name }}-->
                {{ item.vehicleMode }}
              </div>
              <div class="list-3">
                <!--              {{ item.phone }}-->
                {{ item.vehicleLength }}米
              </div>
            </div>
            <div class="center-box-2">
              <div>
                <span class="box-value">{{ item.companyName }}</span>
                <span class="box-value pl10">{{ item.username }}</span>
                <span class="box-value pl10">{{ item.phone }}</span>
              </div>
              <div>
                <span class="box-value">承运条数：</span>
                <span>{{ item.currentOrderNum }}条</span>
                <span class="box-value pl10">上报状态：</span>
                <!--                <span class=" status-error" v-if="item.reportStatus === 3">休息中</span>-->
                <span class=" status-cancel" v-if="item.reportStatus === 2">装满发车</span>
                <span class=" status-confirm" v-if="item.reportStatus === 1">接单中</span>
                <span class=" status-pending-order" v-if="item.reportStatus === 0">未上报</span>
              </div>
            </div>
          </div>
        </template>

        <div class="no-data" v-else>
          <el-empty :image-size="100" description="暂无司机"></el-empty>
        </div>
      </div>
      <div class="pagination-box">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableOptions.pageNumber"
          :page-size="tableOptions.pageSize"
          background
          layout="total, prev, pager, next"
          :total="tableOptions.total" />
      </div>
    </div>
    <!--    <div class="left-box" v-show="selectUserId">-->
    <div class="left-box" v-loading="loading">
      <div class="map-box">
        <div id="container" style="width: 100%; height: 100%"></div>
      </div>
      <div class="control-box" v-if="selectUserId">
        <div class="control-box-top">
          <div class="top-check">
            <div class="check-tab" @click="selectTab('real')" :class="selectLabel === 'real' ? 'check-tab-select' : ''">
              实时状态
            </div>
            <div class="check-tab" @click="selectTab('car')" :class="selectLabel === 'car' ? 'check-tab-select' : ''">
              车辆轨迹
            </div>
          </div>
          <div class="control-date" v-if="selectLabel === 'real'">
            <span>数据更新时间:{{ realData.gpsTime }}</span>
            <span class="refresh-icon" @click="handleRefresh"><i class="el-icon-refresh"></i></span>
          </div>
          <div class="control-date" v-if="selectLabel === 'car'">
            <div>
              <custom-date-range
                :clearable="false"
                :max-range-days="1"
                type="datetimerange"
                value-format="yyyy-MM-dd HH:mm:ss"
                :start-date="searchFormCar.startTime"
                :end-date="searchFormCar.endTime"
                @update:startDate="handleStartDateChange"
                @update:endDate="handleEndDateChange"></custom-date-range>
            </div>
            <el-button
              type="primary"
              round
              style="margin-left: 0.1rem"
              icon="el-icon-search"
              :disabled="btnDisabled"
              @click="getDriverTracksData()"></el-button>
          </div>
        </div>
        <el-row v-if="selectLabel === 'real'">
          <div class="control-box-bottom">
            <div>
              <el-col :span="6">
                <span class="label">实时位置：</span>
                <span class="value hover" @click="getGPSLocationData()">点击获取实时位置</span>
              </el-col>
              <el-col :span="6">
                <span class="label">车辆运行状态：</span>
                <span class="value">
                  <!--                  <span class=" status-error" v-if="selectDriverObj.reportStatus === 3">休息中</span>-->
                  <span class=" status-cancel" v-if="selectDriverObj.reportStatus === 2">装满发车</span>
                  <span class=" status-confirm" v-if="selectDriverObj.reportStatus === 1">接单中</span>
                  <span class=" status-pending-order" v-if="selectDriverObj.reportStatus === 0">未上报</span>
                </span>
              </el-col>

              <el-col :span="12">
                <span class="label">装载货物：</span>
                <span class="value">
                  <span>{{setCargoNames(realData.cargoNames)}}</span>
                </span>
              </el-col>
            </div>
            <div>
              <el-col :span="6">
                <span class="label">时速：</span>
                <span class="value" v-if="realData.speed !== null">{{ realData.speed }}km/h</span>
                <span class="value" v-else>-</span>
              </el-col>
              <el-col :span="6">
                <span class="label">当前货物载重：</span>
                <span class="value">{{ realData.cargoWeight }}吨</span>
              </el-col>
              <el-col :span="6">
                <span class="label">承运订单数：</span>
                <span class="value">{{ selectDriverObj.currentOrderNum }}单</span>
              </el-col>
            </div>
          </div>
        </el-row>
        <el-row v-if="selectLabel === 'car'">
          <div class="control-box-bottom">
            <div class="gui-ji-box">
              <div class="gui-label">{{ searchFormCar.startTime }}</div>
              <el-slider
                class="gui-slider"
                v-model="carPoly"
                :min="transformTimestamp(searchFormCar.startTime)"
                :max="transformTimestamp(searchFormCar.endTime)"
                :format-tooltip="formatTooltip"></el-slider>

              <!--              :format-tooltip="formatTooltip"-->
              <!--              <div class="gui-box">-->
              <!--                <div class="gui-content">-->
              <!--                  <div class="curson-po"></div>-->
              <!--                </div>-->
              <!--              </div>-->
              <div class="gui-label">{{ searchFormCar.endTime }}</div>
            </div>
            <div>
              <!--              <el-col :span="8">-->
              <!--                <span class="label">运行公里数：</span>-->
              <!--                <span class="value color52C41A">没有字段</span>-->
              <!--              </el-col>-->
              <el-col :span="8">
                <span class="label">车速：</span>
                <span class="value" v-if="realData.speed !== null">{{ realData.speed }}km/h</span>
                <span class="value" v-else>-</span>
              </el-col>
              <!--              <el-col :span="8">-->
              <!--                <span class="label">位置信息：</span>-->
              <!--                <span class="value">没有字段</span>-->
              <!--              </el-col>-->
            </div>
          </div>
        </el-row>
      </div>
    </div>
    <!--    <div class="left-box no-data" v-show="!selectUserId">-->
    <!--      <el-empty :image-size="100" description="请点击选择司机"></el-empty>-->
    <!--    </div>-->
  </div>
</template>

<script>
import OperateBox from "@/components/OperateBox.vue";
import CustomTable from "@/components/CustomTable.vue";
import CustomDateRange from "@/components/CustomDateRange.vue";
import {getDriversPage, getDriverTracks, getGPSLocation} from "./api";
import tableMixin from "@/mixin/tableMixin";
import { getTree } from "@/views/commonApi";
import AMapLoader from "@amap/amap-jsapi-loader";
import {debounce} from "lodash";
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.tz.setDefault("Asia/Shanghai")

export default {
  name: "OrderManagement",
  mixins: [tableMixin],
  components: {
    OperateBox,
    CustomTable,
    CustomDateRange,
  },
  data() {
    return {
      getTableMethod: getDriversPage,
      loading: false,
      isImmediatelyGetData: true,
      searchForm: {
        keyword: ""
      },
      searchFormCar: {
        startTime: "",
        endTime: "",
      },
      deptList: [],
      selectOrderId: "",
      selectUserId: "",
      cheImage: require("@/assets/imgs/title.png"),
      cImage: require("@/assets/imgs/che.png"),
      selectLabel: "real",
      map: null,
      polyline: null,
      markers: [],
      carPoly: null,
      debounceTimer: null,
      realData: {},
      carData: [],
      btnDisabled: false,
      selectDriverObj: {},
      iconMarkers: [],   // 旋转的车图标
      labelMarkers: []   // 水平的司机名称/车牌号
    };
  },
  computed: {
    lineArr: function () {
      const result = this.carData.map(item => ({
        ...item,
        longAndLat: [
          parseFloat(item.lng) || 0,
          parseFloat(item.lat) || 0
        ]
      }));
      return result
    },
  },
  watch: {
    "searchFormCar.startTime": function(val) {
      if (val) {
        this.btnDisabled = false
      } else {
        this.btnDisabled = true
      }
    },
    carPoly(val) {
      // 先清除上一次的定时器（实现防抖）
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer);
      }

      // 停止操作 300ms 后再执行（时间可改）
      this.debounceTimer = setTimeout(() => {
        // -------- 下面是你原来的逻辑，完全不动 --------
        if (!val || !this.lineArr.length) return;

        // 匹配时间最近的轨迹点
        let targetPoint = this.lineArr.reduce((prev, curr) => {
          const prevTime = this.transformTimestamp(prev.gpsTime);
          const currTime = this.transformTimestamp(curr.gpsTime);
          return Math.abs(currTime - val) < Math.abs(prevTime - val) ? curr : prev;
        });

        if (targetPoint) {
          this.clearMarkers();
          // 传递经纬度 + 方向字段
          const newCar = {
            lng: targetPoint.longAndLat[0],
            lat: targetPoint.longAndLat[1],
            carNumber: this.selectDriverObj?.carNumber || '车辆',
            direction: targetPoint.direction || 0
          };
          this.setMapMarkers([newCar]);
        }
        // -------- 原来的逻辑结束 --------
      }, 300); // 300ms 无操作才执行，可改 200/500
    },
  },
  created() {},
  mounted() {
    this.initAMap();
  },
  beforeDestroy() {
    this.map?.destroy();
  },
  methods: {// 选择开始时间
    handleStartDateChange(val) {
      this.searchFormCar.startTime = val;
      this.searchFormCar.endTime = ""; // 清空结束时间

    },

// 选择结束时间 —— 强制必须相差 24 小时
    handleEndDateChange(val) {
      const start = this.searchFormCar.startTime;
      const end = val;

      if (!start || !end) return;

      const startStamp = dayjs(start).valueOf();
      const endStamp = dayjs(end).valueOf();

      // 固定 24小时 = 86400000 毫秒
      const oneDay = 24 * 60 * 60 * 1000;

      // 必须严格等于 24 小时
      if (endStamp - startStamp !== oneDay) {
        this.$message.error("时间范围必须为 24小时（1天）！");
        this.searchFormCar.endTime = "";
        return;
      }

      this.searchFormCar.endTime = val;
    },
    setCargoNames(val) {
      if (val && val.length > 0) {
        return val.join(",")
      } else {
        return val
      }
    },
    handleSearch: debounce(function (val) {
      this.tableOptions.currentPage = 1
      this.getTableData();
    }, 500),
    formatTooltip(timestamp) {
      return dayjs(timestamp).format('YYYY-MM-DD HH:mm:ss')
    },
    // 日期转时间戳
    transformTimestamp(dateTime) {
      if (!dateTime) return 0;
      return dayjs(dateTime).valueOf();
    },
    getLotAndLat(timestamp) {
      let arr = [];
      let item = this.carLineArr.filter((item) => {
        item.longitude = timestamp;
      });
      if (item) {
        this.arr = item.longAndLat;
      }
      return arr;
    },
    initAMap() {
      window._AMapSecurityConfig = {
        securityJsCode: "e91f06bab5d88c39e294f7f17fc4d203",
      };
      AMapLoader.load({
        key: "efc1307b7fb723a63df25c4654808f21",
        version: "2.0",
        plugins: ["AMap.Scale", "AMap.PlaceSearch", "AMap.Geocoder"],
      })
        .then((AMap) => {
          this.map = new AMap.Map("container", {
            viewMode: "3D",
            zoom: 11,
            resizeEnable: true,
            center: [119.412834, 32.394404],
          });
        })
        .catch((e) => {
          // // console.log(e);
        });
    },
    clearMarkers() {
      // 清图标
      this.iconMarkers.forEach(m => this.map.remove(m));
      this.iconMarkers = [];

      // 清文字
      this.labelMarkers.forEach(m => this.map.remove(m));
      this.labelMarkers = [];
    },

    // 重点改造：接收 direction 并设置图标旋转角度
    setMapMarkers(arr) {
      let that = this;

      // 先清旧的
      this.clearMarkers();

      arr.forEach((item) => {
        if (!item.lng || !item.lat) return;

        const pos = new AMap.LngLat(item.lng, item.lat);
        const carNumber = item.carNumber || this.selectDriverObj?.carNumber || '车辆';
        const direction = Number(item.direction) || 0;

        // 1）车图标 Marker（会旋转）
        const iconMarker = new AMap.Marker({
          position: pos,
          icon: that.cImage,
          offset: new AMap.Pixel(-20, -20),
          size: [40, 40],
          angle: 360 - direction // 只旋转这个
        });
        iconMarker.setTitle(carNumber);
        this.iconMarkers.push(iconMarker);

        // 2）纯文字 Marker（不旋转、永远水平）
        const labelMarker = new AMap.Marker({
          position: pos,
          content: `<div style="
        background: rgba(0,0,0,0.6);
        color: #fff;
        font-size: 12px;
        padding: 4px 6px;
        border-radius: 4px;
        white-space: nowrap;
      ">${carNumber}</div>`,
          offset: new AMap.Pixel(0, -45) // 放在车上方
        });
        this.labelMarkers.push(labelMarker);
      });

      // 全部加到地图
      this.map.add(this.iconMarkers);
      this.map.add(this.labelMarkers);
      this.map.setFitView();
    },
    setPolyline(arr) {
      this.polyline = new AMap.Polyline({
        map: this.map,
        path: arr.map(item => item.longAndLat),
        showDir: true,
        strokeColor: "#28F",
        strokeWeight: 6,
      });
      this.map.add(this.polyline);
      // 轨迹初始点位，带入方向
      let item = {
        lng: arr[0].longAndLat[0],
        lat: arr[0].longAndLat[1],
        carNumber: this.selectDriverObj.carNumber,
        direction: arr[0].direction || 0
      };
      this.setMapMarkers([item]);
    },
    clearPolyline() {
      if (this.polyline) {
        this.map.remove(this.polyline);
        this.polyline = null;
      }
    },
    setNowTime() {
      const now = dayjs();
      this.searchFormCar.startTime = now.subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss');
      this.searchFormCar.endTime = now.format('YYYY-MM-DD HH:mm:ss');
    },
    selectTab(val) {
      this.selectLabel = val;
      if (val === "car") {
        this.setNowTime()
        this.getDriverTracksData(this.selectUserId)
      } else if (val === "real") {
        this.getGPSLocationData(this.selectUserId)
      }
    },
    getTree() {
      getTree().then((res) => {
        if (res.code === 200) {
          this.deptList = res.data;
        }
      });
    },
    handleRefresh() {
      this.getGPSLocationData()
    },
    handleClick(item) {
      this.selectDriverObj = Object.assign({}, item);
      this.selectUserId = item.driverId;
      if (this.selectLabel === "real") {
        this.getGPSLocationData()
      } else {
        this.getDriverTracksData()
      }
    },
    getGPSLocationData() {
      this.loading = true
      this.clearPolyline();
      this.clearMarkers();
      getGPSLocation(this.selectUserId).then((res) => {
        if (res.code === 200) {
          // // console.log("11111111111111111111111111", res.data);
          this.realData = res.data;
          if (res.data.lat && res.data.lng) {
            // 实时数据也携带方向字段
            this.setMapMarkers([{
              ...res.data,
              carNumber: this.selectDriverObj.carNumber
            }]);
          } else {
            this.$message.error("暂无位置信息");
          }

        }
      }).finally(() => {
        this.loading = false
      });
    },
    getDriverTracksData() {
      this.loading = true
      this.clearPolyline();
      this.clearMarkers();
      this.carPoly = this.transformTimestamp(this.searchFormCar.startTime)
      getDriverTracks({
        driverId: this.selectUserId,
        startTime: this.searchFormCar.startTime,
        endTime: this.searchFormCar.endTime,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data && res.data.length > 0) {
            this.carData = res.data;
            this.setPolyline(this.lineArr);
          } else {
            this.$message.error("暂无轨迹信息");
          }
        }
      }).finally(() => {
        this.loading = false
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.order-review {
  display: flex;
  height: 100%;
  overflow: hidden;
  flex-direction: row;
  padding: 0.2rem;
  box-sizing: border-box;
  .left-box {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 0.2rem 0.2rem 0.1rem 0.2rem;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 0.08rem;
    .map-box {
      flex: 1;
      width: 100%;
      background-color: #eeeeee;
      border-radius: 0.08rem;
    }
    .control-box {
      width: 100%;
      height: 1.8rem;
      padding: 0 0 0.2rem;
      box-sizing: border-box;
      .control-box-top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        //margin-bottom: 0.2rem;
        height: 0.7rem;
        .control-date {
          display: flex;
          align-items: center;
          span {
            color: #8c8c8c;
            padding-right: 0.1rem;
          }
          .refresh-icon {
            .el-icon-refresh {
              color: #000000;
              cursor: pointer;
              font-size: 0.16rem;
            }
          }
        }
      }
      .control-box-bottom {
        width: 100%;
        height: 0.97rem;
        background-color: #f7fbff;
        border-radius: 0.08rem;
        padding: 0.24rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .gui-ji-box {
          display: flex;
          align-items: center;
          .gui-label {
            color: #8c8c8c;
            flex: 0 0 auto;
          }
          .gui-slider {
            width: 100%;
            margin: 0 0.2rem;
          }
          .gui-box {
            height: 0.1rem;
            flex: 1 1 auto;
            background-color: #e9f0f7;
            border-radius: 0.18rem;
            margin: 0 0.2rem;
            .gui-content {
              width: 50%;
              height: 100%;
              background: linear-gradient(90deg, #ebffe2 0%, #8bdf62 100%);
              position: relative;
              .curson-po {
                width: 0.1rem;
                height: 0.1rem;
                background-color: rgba(98, 219, 158, 1);
                border-radius: 50%;
                position: absolute;
                right: -0.05rem;
                top: 50%;
                transform: translateY(-50%);
                border: 0.03rem solid rgba(98, 219, 158, 0.06);
              }
            }
          }
        }
      }
    }
  }
  .right-box {
    width: 25%;
    height: 100%;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    //padding-right: 0.2rem;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    box-sizing: border-box;
    background-color: #ffffff;
    border-radius: 0.08rem;
    margin-right: 0.2rem;
    .right-top {
      height: 0.7rem;
      box-sizing: border-box;
      flex-shrink: 0;
      background-color: #ffffff;
      .right-title {
        padding: 0.2rem 0 0;
        .title-label {
          width: 0.08rem;
          height: 0.08rem;
          margin-right: 0.06rem;
        }
      }
      .right-search {
        margin: 0.2rem 0;
      }
    }
    .right-center-box {
      flex: 1;
      overflow-y: auto; /* 允许垂直滚动 */
      box-sizing: border-box;
      //padding-right: 0.2rem;

      .center-box {
        width: 100%;
        background-color: #fbfcff;
        border-radius: 0.08rem;
        cursor: pointer;
        margin-bottom: 0.2rem;
        border: 0.01rem solid #fbfcff;
        padding: 0.1rem;
        box-sizing: border-box;
        .center-box-1 {
          display: flex;
          align-items: center;
          margin-bottom: 0.08rem;
          .list-1 {
            display: flex;
            align-items: center;

            .label-img {
              width: 0.14rem;
              height: 0.14rem;
            }
            .center-name {
              line-height: 0.2rem;
              padding-left: 0.04rem;
              color: #000000;
              font-size: 0.14rem;
            }
          }
          .list-2,
          .list-3 {
            font-size: 0.12rem;
            color: #000000;
          }
          .list-2 {
            padding: 0 0.2rem;
            position: relative;
            &::before {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              left: 0.1rem;
            }
            &::after {
              content: "";
              width: 0.01rem;
              height: 0.1rem;
              background-color: #dce5f5;
              position: absolute;
              right: 0.1rem;
            }
          }
        }
        .center-box-2 {
          color: #8c8c8c;
          font-size: 0.12rem;
          line-height: 0.26rem;

          .box-value {
            color: #434343;
          }
        }
      }
      .selectTab {
        border: 0.01rem solid #1269ff;
        background-color: rgba(18, 105, 255, 0.05);
      }
    }
  }
  .custom-table-box {
    padding-top: 0;
    .pagination-box {
      display: flex;
      justify-content: right;
      margin-top: 0.4rem;
    }
  }
  ::v-deep .amap-marker-label {
    background-color: rgba(38, 14, 14, 0.2);
    padding: 0.06rem 0.1rem;
    color: #ffffff;
    font-size: 0.14rem;
    border: none;
    border-radius: 0.7rem;
  }
}
.pagination-box {
  display: flex;
  justify-content: right;
  padding: 0.2rem 0.2rem 0.2rem 0;
  background-color: #fff;
}
</style>
